/**
 * Maps backend error codes to friendly, privacy-safe UI copy (spec §15.1).
 * Never render the backend `message`/`details` — always go through this catalog.
 */
import { ROUTES } from './routes';

export interface ErrorPresentation {
  title: string;
  /** CTA label. */
  ctaLabel: string;
  /** Where the CTA goes. Internal route or 'retry-login'. */
  ctaTarget: string;
}

const CATALOG: Record<string, ErrorPresentation> = {
  OAUTH_CANCELLED: { title: 'Bạn đã hủy đăng nhập', ctaLabel: 'Thử lại', ctaTarget: ROUTES.login },
  OAUTH_STATE_INVALID: {
    title: 'Phiên đăng nhập không hợp lệ',
    ctaLabel: 'Đăng nhập lại',
    ctaTarget: ROUTES.login,
  },
  OAUTH_STATE_EXPIRED: {
    title: 'Phiên đăng nhập đã hết hạn',
    ctaLabel: 'Đăng nhập lại',
    ctaTarget: ROUTES.login,
  },
  PROVIDER_DISABLED: {
    title: 'Phương thức đăng nhập hiện chưa khả dụng',
    ctaLabel: 'Quay lại',
    ctaTarget: ROUTES.login,
  },
  PROVIDER_UNAVAILABLE: {
    title: 'Không thể kết nối dịch vụ đăng nhập',
    ctaLabel: 'Thử lại sau',
    ctaTarget: ROUTES.login,
  },
  TOKEN_EXCHANGE_FAILED: {
    title: 'Không thể hoàn tất đăng nhập',
    ctaLabel: 'Thử lại',
    ctaTarget: ROUTES.login,
  },
  IDENTITY_ALREADY_LINKED: {
    title: 'Tài khoản này đã được liên kết',
    ctaLabel: 'Quay lại kết nối',
    ctaTarget: ROUTES.connections,
  },
  EMAIL_CONFLICT_LINK_REQUIRED: {
    title: 'Email này đã tồn tại trong một tài khoản khác',
    ctaLabel: 'Đăng nhập bằng phương thức trước đó',
    ctaTarget: ROUTES.login,
  },
  LAST_AUTH_METHOD: {
    title: 'Không thể gỡ phương thức cuối cùng',
    ctaLabel: 'Quay lại kết nối',
    ctaTarget: ROUTES.connections,
  },
  ACCOUNT_SUSPENDED: {
    title: 'Tài khoản của bạn đang bị tạm khóa',
    ctaLabel: 'Liên hệ hỗ trợ',
    ctaTarget: ROUTES.login,
  },
  SESSION_NOT_CREATED: {
    title: 'Không thể tạo phiên đăng nhập',
    ctaLabel: 'Thử đăng nhập lại',
    ctaTarget: ROUTES.login,
  },
};

const UNKNOWN: ErrorPresentation = {
  title: 'Đã có lỗi xảy ra',
  ctaLabel: 'Thử lại',
  ctaTarget: ROUTES.login,
};

export function presentError(code: string | null | undefined): ErrorPresentation {
  if (!code) return UNKNOWN;
  return CATALOG[code] ?? UNKNOWN;
}

export const KNOWN_ERROR_CODES = Object.keys(CATALOG);
